import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {QueryRatingsVariablesType} from "../../definitions/types";
import {ItemClassificationType, RatingPaginationSortType, SentimentType} from "../../definitions/enums";

const viewModel = window.viewModel;

export const name = "ratingPagination";

const ratingPaginationSlice = createSlice({
    initialState: {
        value: {
            filters: {
                grades: [],
                sentiments: []
            },
            id: viewModel.primaryId ?? viewModel.productId,
            productId: viewModel.productId,
            pageNumber: 0,
            pageSize: 10,
            searchTerm: undefined,
            sortBy: RatingPaginationSortType.ReverseChronological,
            type: viewModel.primaryId ? ItemClassificationType.Primary : ItemClassificationType.Standalone
        } as QueryRatingsVariablesType
    },
    name: name,
    reducers: {
        clearFilters: (state) => {
            state.value.filters = {
                grades: [],
                sentiments: []
            };
        },
        set: (state, action: PayloadAction<QueryRatingsVariablesType>) => {
            state.value = action.payload;
        },
        setProduct: (state, action: PayloadAction<Pick<QueryRatingsVariablesType, "id" | "type" | "productId">>) => {
            state.value.id = action.payload.id;
            state.value.type = action.payload.type;
            state.value.productId = action.payload.productId;
        },
        setSearchTerm: (state, action: PayloadAction<string | undefined>) => {
            state.value.searchTerm = action.payload?.trim() ? action.payload.trim() : undefined;
        },
        setSortBy: (state, action: PayloadAction<RatingPaginationSortType>) => {
            state.value.sortBy = action.payload;
        },
        toggleSentimentFilter: (state, action: PayloadAction<SentimentType>) => {
            const copy = [...state.value.filters.sentiments];
            const index = copy.indexOf(action.payload);
            if (index === -1) {
                copy.push(action.payload);
            } else {
                copy.splice(index, 1);
            }
            state.value.filters.sentiments = copy;
        },
        toggleStarFilter: (state, action: PayloadAction<1 | 2 | 3 | 4 | 5>) => {
            const copy = [...state.value.filters.grades];
            const index = copy.indexOf(action.payload);
            if (index === -1) {
                copy.push(action.payload);
            } else {
                copy.splice(index, 1);
            }
            state.value.filters.grades = copy.sort((a, b) => a - b);
        },
        update: (state, action: PayloadAction<Partial<QueryRatingsVariablesType>>) => {
            state.value = {...state.value, ...action.payload};
        }
    }
});

export const {
    set: setRatingPagination,
    update: updateRatingPagination,
    setProduct: setRatingPaginationProduct,
    setSortBy: setRatingPaginationSortBy,
    setSearchTerm: setRatingPaginationSearchTerm,
    toggleStarFilter: toggleRatingPaginationStarFilter,
    toggleSentimentFilter: toggleRatingPaginationSentimentFilter,
    clearFilters: clearRatingPaginationFilters
} = ratingPaginationSlice.actions;
export default ratingPaginationSlice.reducer;